/**
 * Created by linjianxi on 2016/10/29.
 */
import * as types from './mutation-type'
import * as http from '../../../utils/common'
import { session } from '../../../utils/storage'

/**
 * 获取税率
 * @param commit
 * @param params
 */
export const getTax = ({commit}, params) => {
  http.post({
    url: '/api/FundSearch/GetTax',
    data: params,
    succ: function (res) {
      if (res.result === 1) {
        commit(types.GET_HQPORD_INTO_LIST, res.data)
      } else {
        alert(res.message)
      }
    }
  })
}
/**
 * 提现到活期宝
 * @param commit
 * @param params
 */
export const hqbRecharge = ({commit}, params) => {
  let _this = params._this
  http.post({
    url: '/api/FundHqb/HqbRecharge',
    data: params,
    succ: function (res) {
      if (res.result === 1) {
        session.setItem(res.data.applyid, JSON.stringify(res.data))
        if (params.couponid !== undefined) {
          _this.$router.replace({path: '/action/resutlstatu/' + res.data.applyid + '/0'})
        } else {
          _this.$router.push({path: '/action/resutlstatu/' + res.data.applyid + '/0'})
        }
      } else {
        alert(res.message)
      }
    }
  }, _this.$store.commit)
}

/**
 * 初始税率和金额
 * @param commit
 */
export const changeSl = ({commit}) => {
  commit(types.GET_HQPORD_INTO_RECHANGE)
}
/**
 * 获取浪客直播账户详情
 * @param commit
 * @param params
 */
export const getIntoDetail = ({commit}, params) => {
  http.post({
    url: '/api/FundSearch/GetLiveAccounts',
    data: {reqtype: 1},
    succ: function (res) {
      console.log(res)
      if (res.result === 1) {
        commit(types.GET_HQPORD_DETAIL, {res: {_this: params._this, req: res.data}})
      } else {
        alert(res.message)
      }
    }
  }, params._this.$store.commit)
}




// WEBPACK FOOTER //
// ./src/vuex/modules/hqpord_into/actions.js